import bookingRoomAssignmentChosen from "./bookingRoomAssignmentChosen";

export default bookingRoomAssignmentChosen;
